/**
 * Labstep
 *
 * @module state/reducers/entity/updatingIds;
 * @desc Reducer for updated entities
 */

import handleAction from 'labstep-web/state/reducers/entity/utils';

/**
 * Returns reducer for updated entities
 *
 * @function
 * @param  {object} state - Redux state
 * @param  {string} action - Redux action
 */
const updatingIds =
  (entityName: string, entityNameUppercase: string) =>
  (state: any = {}, action: any): any =>
    handleAction(
      state,
      action,
      'UPDATE',
      action.meta && action.meta.identifier,
      entityName,
      entityNameUppercase,
    );

export default updatingIds;
